import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import { Nav, NavItem, NavLink } from 'reactstrap';

export type Tab = {
  name: string;
  enabled?: boolean;
};

type Props<T extends Tab> = {
  tabs: T[];
  activeTab: T | undefined | null;
  handleClickTab: (tab: T) => void;
};

export default function NavigationTabs<T extends Tab>({
  tabs,
  activeTab,
  handleClickTab
}: Props<T>): ReactElement {
  return (
    <Nav tabs>
      {tabs.map((tab) => {
        const active = activeTab?.name === tab.name;
        return (
          <NavItem key={tab.name} onClick={(): void => handleClickTab(tab)}>
            <NavLink className={clsx({ active, disabled: tab?.enabled === false })}>
              {tab.name}
            </NavLink>
          </NavItem>
        );
      })}
    </Nav>
  );
}
